export default __webpack_public_path__ + "static/media/IconYoutube.efaaa085.svg";